import React from 'react';
import { motion } from 'framer-motion';
import { Sparkles } from 'lucide-react';
export function ProductSection() {
  return <section className="py-6 md:py-10 bg-stone-50" data-id="element-340">
      <div className="max-w-xl mx-auto px-5" data-id="element-341">
        {/* Main headline */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="text-center mb-5" data-id="element-342">
          <div className="inline-flex items-center gap-1.5 bg-brand-50 text-brand-600 px-3 py-1 rounded-full text-xs font-bold mb-3 border border-brand-200" data-id="element-343">
            <Sparkles className="w-3 h-3" data-id="element-344" />O MÉTODO
          </div>

          <h2 className="text-2xl md:text-3xl font-bold text-stone-900 leading-tight" data-id="element-345">
            O que é o <span className="text-brand-600" data-id="element-346">Efeito Boutique™</span>
          </h2>
        </motion.div>

        {/* Content */}
        <motion.div initial={{
        opacity: 0,
        y: 15
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5,
        delay: 0.1
      }} className="text-left space-y-4" data-id="element-347">
          <p className="text-sm md:text-[15px] text-stone-600 leading-relaxed tracking-[-0.01em]" data-id="element-348">
            Existe uma diferença específica entre uma lembrancinha que parece
            barata e uma que parece de Boutique.
          </p>

          <p className="text-sm md:text-[15px] text-stone-600 leading-relaxed tracking-[-0.01em]" data-id="element-349">
            Não é o material. Não é o preço.{' '}
            <span className="text-stone-900 font-bold" data-id="element-350">
              É a forma de apresentar.
            </span>
          </p>
        </motion.div>

        {/* What it teaches */}
        <motion.div initial={{
        opacity: 0,
        y: 15
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5,
        delay: 0.2
      }} className="text-left mt-6" data-id="element-351">
          <p className="text-sm md:text-[15px] text-stone-700 leading-relaxed tracking-[-0.01em]" data-id="element-352">
            Isso é o que o Efeito Boutique™ ensina:
          </p>
          <p className="text-sm md:text-base text-stone-700 leading-relaxed mt-2 tracking-[-0.01em]" data-id="element-353">
            3 módulos práticos em que você aprende a{' '}
            <span className="text-brand-600 font-bold" data-id="element-354">
              enxergar, escolher e montar
            </span>{' '}
            com critério — como os grandes fornecedores fazem.
          </p>
        </motion.div>
      </div>
    </section>;
}